module.exports = __webpack_public_path__ + "static/media/black-filled-crown.fd707d0b.svg";